// 域名包含 .com 时视为正式站
const isProduction = location.host.indexOf('.com') !== -1

export default {
  isProduction,
  baseURL: isProduction ? 'https://apimanage.rakumart.com' : 'https://jpapi.rakumart.cn',
};
